import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import "react";
import "../../../node_modules/.pnpm/katex@0.10.2/node_modules/katex/dist/katex.js";
/* empty css                                                                             */
import { QuizResultFeedback } from "../shared/quiz-result-feedback.js";
import { useTranslation } from "react-i18next";
import "../shared/quiz-style-context.js";
import { SubmitButton } from "../shared/submit-button.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import { QuizHeader } from "../shared/quiz-header.js";
import { QuizSolveDescription } from "../shared/quiz-solve-description.js";
import { formatText } from "../../../utils/quiz-parser.js";
import { useImageSelectQuiz } from "../hooks/use-image-select-quiz.js";
import { motion } from "../../../node_modules/.pnpm/framer-motion@11.18.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/components/motion/proxy.js";
function ImageSelectQuizAdult({
  quizId,
  quiz,
  onSolve,
  solveResult,
  showReallyTrue = false,
  isViewSolved = false,
  initialAnswers: initialAnswersProp,
  submitLabel,
  hideSubmitButton = false,
  onAnswerChange,
  disableSound = false,
  difficultyLevel,
  hideExplanation = false
}) {
  const { t } = useTranslation("quiz");
  const {
    selectedKeys,
    isSolved,
    canSubmit,
    shouldShowCorrectAnswers,
    isShowingCorrectAnswers,
    setIsShowingCorrectAnswers,
    handleToggle,
    handleSubmit
  } = useImageSelectQuiz({
    quizId,
    quiz,
    onSolve,
    solveResult,
    showReallyTrue,
    isViewSolved,
    initialAnswers: initialAnswersProp,
    onAnswerChange
  });
  return /* @__PURE__ */ jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsx(
      QuizHeader,
      {
        quizId,
        typeLabel: t("types.imageSelect.label"),
        title: quiz.title,
        difficultyLevel,
        image: void 0,
        imageMobile: void 0,
        desmos: quiz.desmos,
        vars: quiz.vars,
        problem: quiz.problem && /* @__PURE__ */ jsx("div", { className: "text-xl leading-relaxed text-gray-900", children: formatText(quiz.problem, `${quizId}-problem`, quiz.additionalImages ?? void 0) })
      }
    ),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { delay: 0.1 },
        className: "flex items-center justify-center",
        children: /* @__PURE__ */ jsxs("div", { className: "relative inline-block", children: [
          quiz.image && /* @__PURE__ */ jsx(
            "img",
            {
              src: quiz.image.signedUrl || quiz.image.url,
              alt: "quiz",
              className: "max-w-full h-auto"
            }
          ),
          quiz.choices.map((rect) => {
            var _a;
            const isSelected = selectedKeys.has(rect.key);
            const isCorrectAnswer = (_a = solveResult == null ? void 0 : solveResult.correctAnswers) == null ? void 0 : _a.includes(rect.key);
            const x = Math.max(0, rect.x);
            const y = Math.max(0, rect.y);
            const width = rect.x + rect.width > 100 ? 100 - rect.x : rect.width;
            const height = rect.y + rect.height > 100 ? 100 - rect.y : rect.height;
            const showAsCorrect = isSolved && shouldShowCorrectAnswers && isCorrectAnswer;
            const showAsMyCorrect = isSolved && !shouldShowCorrectAnswers && isSelected && isCorrectAnswer;
            const showAsWrong = isSolved && !shouldShowCorrectAnswers && isSelected && !isCorrectAnswer;
            return /* @__PURE__ */ jsx(
              "button",
              {
                onClick: () => handleToggle(rect.key),
                disabled: isSolved || isViewSolved,
                className: cn(
                  "group absolute cursor-pointer border-4 border-transparent rounded-xl transition-all",
                  // 호버 (풀이 전, 미선택): 외곽 흰색 테두리
                  !isSolved && !isViewSolved && !isSelected && "hover:border-white hover:shadow-lg",
                  // 선택 (풀이 전): 외곽 흰색 테두리
                  !isSolved && isSelected && "border-white shadow-lg",
                  // 정답/오답 (풀이 후): 외곽 테두리 없음 (transparent 유지)
                  // 비활성화
                  (isSolved || isViewSolved) && "pointer-events-none"
                ),
                style: {
                  left: `${x}%`,
                  top: `${y}%`,
                  width: `${width}%`,
                  height: `${height}%`
                },
                children: /* @__PURE__ */ jsx("div", { className: cn(
                  "absolute inset-0 rounded-lg border-2 transition-all",
                  // 풀이 전 - 미선택: 대시 테두리, 호버 시에만 표시 (opacity)
                  !isSolved && !isSelected && "border-dashed border-[#55C3FF] opacity-0 group-hover:opacity-100",
                  // 풀이 전 - 선택: 실선 테두리 + 배경
                  !isSolved && isSelected && "border-solid border-[#55C3FF] bg-[#55C3FF]/20 opacity-100",
                  // 정답 (내 정답 또는 정답보기)
                  (showAsCorrect || showAsMyCorrect) && "border-solid border-[#3BD0AE] bg-[#3BD0AE]/20 opacity-100",
                  // 오답
                  showAsWrong && "border-solid border-[#FF675E] bg-[#FF675E]/20 opacity-100",
                  // 정답보기 모드 - 정답 영역 강조
                  shouldShowCorrectAnswers && isCorrectAnswer && "border-solid border-[#3BD0AE] bg-[#3BD0AE]/20 opacity-100"
                ) })
              },
              rect.key
            );
          })
        ] })
      }
    ),
    !isSolved && !isViewSolved && !hideSubmitButton && /* @__PURE__ */ jsx(
      SubmitButton,
      {
        onClick: handleSubmit,
        disabled: !canSubmit,
        label: submitLabel ?? (selectedKeys.size === 0 ? t("types.imageSelect.selectArea") : t("common.checkAnswer"))
      }
    ),
    isSolved && /* @__PURE__ */ jsx(
      QuizResultFeedback,
      {
        isCorrect: (solveResult == null ? void 0 : solveResult.correct) ?? false,
        show: isSolved,
        disableSound,
        isViewSolved
      }
    ),
    isSolved && !hideExplanation && /* @__PURE__ */ jsx(
      QuizSolveDescription,
      {
        description: (solveResult == null ? void 0 : solveResult.description) ?? void 0,
        commentaryImages: quiz.commentaryImages,
        vars: quiz.vars,
        id: `${quizId}-desc`,
        actionVisible: !(solveResult == null ? void 0 : solveResult.correct),
        actionLabel: isShowingCorrectAnswers ? t("common.viewMyAnswer") : t("common.viewCorrectAnswer"),
        onActionClick: () => setIsShowingCorrectAnswers((v) => !v)
      }
    )
  ] });
}
export {
  ImageSelectQuizAdult
};
//# sourceMappingURL=image-select-adult.js.map
